import rill from "rill";
import { getReferrerUrl } from "../utils/referrer-url";
import ActivityFeed from "./activity-feed";
import Admin from "./admin";
import AnnualPlanner from "./annual-planner";
import AutomationSending from "./automation-sending";
import Automations from "./automations";
import Billing from "./billing";
import ChallengeReportTemplates from "./challenge-report-templates";
import Chat from "./chat";
import CheckinInsights from "./checkin-insights";
import ClientConfig from "./client-config";
import ClientGoals from "./client-goals";
import ClientNotes from "./client-notes";
import Coach from "./coach";
import CoachDailyMonitoring from "./coach-daily-monitoring";
import CoachMonitoringSettings from "./coach-monitoring-settings";
import CoachSettings from "./coach-settings";
import CoachVideos from "./coach-videos";
import Coaches from "./coaches";
import Common from "./common";
import CommunityChat from "./community-chat";
import Competition from "./competition";
import Complex from "./complex";
import CustomMetrics from "./custom-metrics";
import CustomWorkflows from "./custom-workflows";
import Cycle from "./cycle";
import DailyAccountability from "./daily-accountability";
import DailyStats from "./daily-stats";
import Exercise from "./exercise";
import ExerciseCatalog from "./exercise-catalog";
import ExerciseSection from "./exercise-section";
import ExternalFood from "./external-food";
import FileDocument from "./file-document";
import GettingStarted from "./getting-started";
import Guides from "./guides";
import HabitLogs from "./habit-logs";
import Issue from "./issue";
import Links from "./links";
import MacroCalculator from "./macro-calculator";
import MealPlanLibrary from "./meal-plan-library";
import MealPlanner from "./meal-planner";
import MeetingIntegrations from "./meeting-integrations";
import MyFitnessPalDiary from "./myfitnesspal-diary";
import News from "./news";
import Notification from "./notification";
import Nutrition from "./nutrition";
import NutritionTableTemplates from "./nutrition-table-templates";
import NutritionTdeeOverride from "./nutrition-tdee-override";
import Organizations from "./organizations";
import PersonalRecords from "./personal-records";
import PlanManager from "./plan-manager";
import Questionnaire from "./questionnaire";
import Recipes from "./recipes";
import RepMaximum from "./rep-maximum";
import Scheduling from "./scheduling";
import Stores from "./stores";
import Theme from "./theme";
import User from "./user";
import VideoPlaylist from "./video-playlist";
import WidgetDailyAccountability from "./widget-daily-accountability";
import Widgets from "./widgets";
import WorkoutFolders from "./workout-folders";

const Actions = (app) => {
  app.at(
    "/actions/*",
    rill()
      .get("/refresh", ({ req, res }) => {
        /**
         * This will go back to the previous url (the referrer, defaulting to the dashboard).
         * It updates the query string with the current request query using '@rill/refresh-with'.
         * https://github.com/rill-js/refresh-with
         *
         * "#_" is also appended onto the end of the url to prevent the browser automatically scrolling to the top.
         */
        res.refreshWith(req.query, {
          url: (getReferrerUrl(req) || "/dashboard").replace(/#.*$/, "") + "#_",
        });
      })
      .setup(Billing)
      .setup(ChallengeReportTemplates)
      .setup(CheckinInsights)
      .setup(Competition)
      .setup(Cycle)
      .setup(Exercise)
      .setup(ExerciseSection)
      .setup(Issue)
      .setup(Notification)
      .setup(User)
      .setup(CustomMetrics)
      .setup(RepMaximum)
      .setup(Nutrition)
      .setup(NutritionTableTemplates)
      .setup(NutritionTdeeOverride)
      .setup(PersonalRecords)
      .setup(HabitLogs)
      .setup(MyFitnessPalDiary)
      .setup(Widgets)
      .setup(Recipes)
      .setup(Stores)
      .setup(Links)
      .setup(FileDocument)
      .setup(VideoPlaylist)
      .setup(MacroCalculator)
      .setup(ExerciseCatalog)
      .setup(Admin)
      .setup(Questionnaire)
      .setup(AnnualPlanner)
      .setup(PlanManager)
      .setup(DailyAccountability)
      .setup(Guides)
      .setup(Theme)
      .setup(Organizations)
      .setup(Chat)
      .setup(CoachVideos)
      .setup(CoachSettings)
      .setup(Coaches)
      .setup(Scheduling)
      .setup(MeetingIntegrations)
      .setup(ActivityFeed)
      .setup(CoachDailyMonitoring)
      .setup(CoachMonitoringSettings)
      .setup(CustomWorkflows)
      .setup(AutomationSending)
      .setup(Automations)
      .setup(CommunityChat)
      .setup(GettingStarted)
      .setup(MealPlanLibrary)
      .setup(ActivityFeed)
      .setup(WidgetDailyAccountability)
      .setup(Complex)
      .setup(ClientConfig)
      .setup(ClientGoals)
      .setup(ClientNotes)
      .setup(MealPlanner)
      .setup(Coach)
      .setup(Common)
      .setup(DailyStats)
      .setup(News)
      .setup(WorkoutFolders)
      .setup(ExternalFood)
  );
};

export default Actions;
